import React, { useEffect, Component, useState, useRef } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory, useParams, Link } from 'react-router-dom';
import { ApiService } from '../../containers/Services/apiservice';
import { Watch } from "react-loader-spinner";
let apiServices = new ApiService();
const MfDetail = () => {
  let history = useHistory();
  const didMountRef = useRef(true);
  const { id } = useParams();
  const [mutualfund, setmutualfund] = useState({});
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [CANid, setCANid] = useState('');
  const [InputData, setInputData] = useState({ amount: '', payment_mode: '' });
  const [UserBankData, SetUserBankData] = useState({})
  const [Bankno, setBankno] = useState()
  const [errorMessage, setErrorMessage] = useState('')
  const [BankManApprove, setBankManApprove] = useState()
  const [countermob, setCountermob] = React.useState(0);
  const [otp, Setotp] = useState('');
  const [paymentmode, setpaymentmode] = useState();
  useEffect(() => {
    if (didMountRef.current) {
      setSpinnerLoading(true);
      const dataStringuser = {
      }
      apiServices.getUserData(dataStringuser).then(result => {
        console.log(result)
        if (result.data.status == 'success') {
          setCANid(result.data.data.gs_can_id);
          setBankManApprove(result.data.data.gs_epayezz_bankapprove)
        }
        else if (result.data.status == "error" && result.data.message == "Session expired") {
          localStorage.removeItem('AUTH_TOKEN');
          // alert(result.data.message)
          setSpinnerLoading(false)
          history.push("/login")
        }
        else {
          alert(result.data.message)
          setSpinnerLoading(false)
        }
      })
      const dataStringuser1 = {
      }
      apiServices.getusercanbankdata(dataStringuser1).then(res => {
        if (res.data.status == 'success') {
          SetUserBankData(res.data.data)
        }
        else if (res.data.status == "error" && res.data.message == "Session expired") {
          localStorage.removeItem('AUTH_TOKEN');
          // alert(res.data.message)
          setSpinnerLoading(false)
          history.push("/login")
        }
        else {
          alert(res.data.message)
          setSpinnerLoading(false)
        }
      })
      const dataString = {
        "id": id,
      }
      apiServices.getmutualFunddetailData(dataString).then(res => {
        if (res.data.status == 'success') {
          setmutualfund(res.data.data);
          setSpinnerLoading(false);
        }
        else if (res.data.status == "error" && res.data.message == "Session expired") {
          localStorage.removeItem('AUTH_TOKEN');
          // alert(res.data.message)
          setSpinnerLoading(false)
          history.push("/login")
        }
        else {
          alert(res.data.message)
          setSpinnerLoading(false)
        }
      })
    }
    didMountRef.current = false;
  });
  React.useEffect(() => {
    countermob > 0 && setTimeout(() => setCountermob(countermob - 1), 1000);
  }, [countermob]);
  const handleInput = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setInputData({ ...InputData, [key]: value })
  }
  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }
  const purchasetransaction = (payment_mode) => {
    if (InputData.amount == '') {
      setErrorMessage("Amount is Required");
      return false
    }
    // else if(InputData.amount < mutualfund.minamount-1){
    //   setErrorMessage("Minimum Amount should be more then 500")
    //   return false
    // }
    else if (InputData.payment_mode == '' && payment_mode !== 0) {
      setErrorMessage("PaymentMode is Required");
      return false
    }
    else {
      setErrorMessage('')
    }
    var dataString1 = InputData.payment_mode;
    if (payment_mode == 0) {
      dataString1 = 0;
    }
    const dataString = {
      "amount": InputData.amount,
      "paymentmode": dataString1,
      "schemecode": mutualfund.scheme_code,
      "amccode": mutualfund.fund_code,
      "div_opt": mutualfund.div_opt,
      "bankno": Bankno,
      "mfid": id
    }
    apiServices.purchasetransaction(dataString).then(result => {
      if (result.data.status == 'success') {
        setTimeout(() => {
          history.push("/dashboard");
        }, 3000);
        setSpinnerLoading(false);
        openInNewTab(result.data.redirectURL)
      }
      else if (result.data.status == "error" && result.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(result.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(result.data.message);
        setSpinnerLoading(false);
      }
    })
  }
  const siptransaction = (payment_mode) => {
    if (InputData.amount == '') {
      setErrorMessage("Amount is Required");
      return false
    }
    else if (InputData.payment_mode == '' && payment_mode !== 0) {
      setErrorMessage("PaymentMode is Required");
      return false
    }
    else {
      setErrorMessage('')
    }
    var dataString1 = InputData.payment_mode;
    if (payment_mode == 0) {
      dataString1 = 0;
    }
    const dataString = {
      "amount": InputData.amount,
      "paymentmode": dataString1,
      "schemecode": mutualfund.scheme_code,
      "amccode": mutualfund.fund_code,
      "div_opt": mutualfund.div_opt,
      "bankno": Bankno,
      "mfid": id
    }
    setSpinnerLoading(true);
    apiServices.siptransaction(dataString).then(res => {
      if (res.data.status == 'success') {
        setSpinnerLoading(false);
        siptransaction(false);
        if (res.data.message === 'txn_success') {
          history.push('/thankyou/' + btoa(res.data.txnid))
        } else {
          setSpinnerLoading(false);
          siptransaction(false);
          alert('Some Error Occured Please Try Again');
          Window.location.reload();
        }
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        setSpinnerLoading(false);
        siptransaction(false);
        alert(res.data.message);
        return false;
      }
      // console.log("aaaaa",res.data.PurchaseAndSIPTxnForm);
    })
  }
  const sendotp = (payment_mode) => {
    if (InputData.amount == '') {
      setErrorMessage("Amount is Required");
      return false
    }
    // else if(InputData.amount < mutualfund.minamount-1){
    //   setErrorMessage("Minimum Amount should be more then 500")
    //   return false
    // }
    else if (InputData.payment_mode == '' && payment_mode !== 0) {
      setErrorMessage("PaymentMode is Required");
      return false
    }
    else {
      setErrorMessage('')
    }
    const dataString = {

    }
    setSpinnerLoading(true);
    apiServices.sendtxnotp(dataString).then(result => {
      if (result.data.status == 'success') {
        setSpinnerLoading(false);
        setCountermob(30);
        setpaymentmode(payment_mode);
        setBankManApprove(2)
      }
      else if (result.data.status == "error" && result.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(result.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        setSpinnerLoading(false);
        setErrorMessage(result.data.message);
      }
    })
  }
  const verifyotp = () => {
    const dataString = {
      "mobile_otp": otp
    }
    setSpinnerLoading(true);
    apiServices.verifytxnotp(dataString).then(result => {
      if (result.data.status == 'success') {
        purchasetransaction(paymentmode);
        setSpinnerLoading(false);
      }
      else if (result.data.status == "error" && result.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(result.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        setErrorMessage(result.data.message);
        setSpinnerLoading(false);
      }
    })
  }
  return (
    <div>
      <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
        <div className='overlay-box'>
          <Watch
            color="#ffffff"
            visible={spinnerLoading}
          />
        </div>
      </div>
      <Header />
      {/* <section className='bg-gray-light'> */}
      {BankManApprove == 0
        ? <section className='bg-gray-light section-small'>
          {/* <div className="container-fluid"> */}
          <div className="container">
            <div className='mpanel mg-b-15'>
              <div className='mpanel-header'>
                <h5 className='mg-b-0 fw600'>{mutualfund.plan_name}</h5>
              </div>
              <div className='mpanel-header'>
                <h5 className='mg-b-0 fw600'>ARN : 249633</h5>
              </div>
              <div className='mpanel-header'>
                <h5 className='mg-b-0 fw600'>{CANid}</h5>
              </div>
              <hr></hr>
              <div className='mpanel-body ecan-form'>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="ecan-form-group">
                      <label>Amount<span style={{ color: '#ff0000' }}>*</span></label>
                      <input name="amount" value={InputData.amount} onChange={handleInput} type="number"></input>
                      <span className='inpfeed'>Min Purchase Amount : {mutualfund.minamount}</span>
                    </div>
                  </div>
                  {
                    errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                  }
                  <div className="theme-button mg-t-10">
                    <a onClick={(e) => purchasetransaction(0)} className="btn">
                      {/* <a onClick={(e) => sendotp(0)} className="btn"> */}
                      Proceed
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        : ""}
      {BankManApprove == 1 ?
        <section className='bg-gray-light section-small'>
          {/* <div className="container-fluid"> */}
          <div className="container">
            <div className='mpanel mg-b-15'>
              <div className='mpanel-header'>
                <h5 className='mg-b-0 fw600'>{mutualfund.plan_name}</h5>
              </div>
              <div className='mpanel-header'>
                <h5 className='mg-b-0 fw600'>ARN : 249633</h5>
              </div>
              <div className='mpanel-header'>
                <h5 className='mg-b-0 fw600'>{CANid}</h5>
              </div>
              <hr></hr>
              <div className='mpanel-body ecan-form'>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="ecan-form-group">
                      <label>Amount<span style={{ color: '#ff0000' }}>*</span></label>
                      <input name="amount" value={InputData.amount} onChange={handleInput} type="number"></input>
                      <span className='inpfeed'>Min Purchase Amount : {mutualfund.minamount}</span>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="ecan-form-group">
                      <label>Payment Mode<span style={{ color: '#ff0000' }}>*</span></label>
                      <select name="payment_mode" value={InputData.payment_mode} onChange={handleInput}>
                        <option value="">Select</option>
                        <option value="OT">Net Banking</option>
                        <option value="UP">UPI</option>
                        <option value="DM">PayEezz</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="ecan-form-group">
                      <label>Select Bank Details<span style={{ color: '#ff0000' }}>*</span></label>
                      <select name="bankno" value={Bankno} onChange={(e) => setBankno(e.target.value)}>
                        {UserBankData.crb_bank_acc_no1 != null ?
                          <option value="1">{UserBankData.crb_bank1} -- {UserBankData.crb_bank_acc_no1.replace(/.(?=.{4})/g, 'X')} -- (Primary)</option> : ''
                        }
                        {UserBankData.crb_bank_acc_no2 != null ?
                          <option value="2">{UserBankData.crb_bank2} -- {UserBankData.crb_bank_acc_no2.replace(/.(?=.{4})/g, 'X')}</option> : ''
                        }
                        {UserBankData.crb_bank_acc_no3 != null ?
                          <option value="3">{UserBankData.crb_bank3} -- {UserBankData.crb_bank_acc_no3.replace(/.(?=.{4})/g, 'X')}</option> : ''
                        }
                      </select>
                    </div>
                  </div>
                  {
                    errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                  }
                  <div className="theme-button mg-t-10">
                    <a onClick={(e) => purchasetransaction(1)} className="btn">
                      {/* <a onClick={(e) => sendotp(1)} className="btn"> */}
                      Proceed
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> : ""}
      {BankManApprove == 2 ?
        <section className='bg-gray-light section-small'>
          <div className="container">
            <div className='row justify-content-md-center'>
              <div className='col-lg-8'>
                <div className='mfsipbox mg-b-15'>
                  <div className='mfsipbox-planname'>Verify OTP</div>
                  <div className='mfshipboxform'>
                    <div className='row'>
                      <div className='col-lg-12'>
                        <div className='mfshipboxform-group'>
                          <label>Enter OTP<span style={{ color: '#ff0000' }}>*</span></label>
                          <input name="otp" onChange={(e) => Setotp(e.target.value)} type="number"></input>
                          {
                            countermob == 0 ?
                              <p className="tx-12 mg-t-5"  >Didn't receive OTP? Resend <Link onClick={sendotp}>(Click Here)</Link></p> :
                              <p className="tx-12 mg-t-5"  >Resend OTP in {countermob} seconds</p>
                          }
                        </div>
                        {
                          errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="theme-button mg-t-20"><a class="btn button02" onClick={verifyotp}>Submit</a></div>
              </div>
            </div>
          </div>
        </section> : ""}
      <Footer />
    </div>
  );
}

export default MfDetail;